import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { ProposalMainGridComponent } from "./proposal-main-grid/proposal-main-grid.component";

const routes: Routes = [
    { path: '', component: ProposalMainGridComponent },
    // {
    //     path: ':id',
    //     component: CreateEditItemConfigGridComponent,
    //     canActivate: [DialogGuard],
    //     data: { component: CreateEditItemConfigGridComponent },
    // },
  ];

  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class ProposalRoutingModule { }